/**
 * iWoPlannedOrderModule 串联单-编辑页
 * description:  串联单-编辑页
 * author: Qian.qianchen 2019-04-03
 */
'use strict';
angular.module('iWoPlannedOrderModule', ['preciseTimePickerModule']).controller('iWoPlannedOrderCtrl', [
    '$scope',
    'initeditctrBtnsService',
    'myManuscriptService',
    'trsHttpService',
    'beforeonload',
    '$stateParams',
    'initiWoDataService',
    '$q',
    'editingCenterService',
    '$validation',
    '$window',
    'modalDialog',
    'storageListenerService',
    'editIsLock',
    '$state',
    '$timeout',
    '$filter',
    'newMediaService',
    'iWoService',
    'publicToolService',
    function(
        $scope,
        initeditctrBtnsService,
        myManuscriptService,
        trsHttpService,
        beforeonload,
        $stateParams,
        initiWoDataService,
        $q,
        editingCenterService,
        $validation,
        $window,
        modalDialog,
        storageListenerService,
        editIsLock,
        $state,
        $timeout,
        $filter,
        newMediaService,
        iWoService,
        publicToolService
    ) {
        $scope = iWoService.addFuture($scope, ['sendmessage']);
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                plannedOrderFormError: [],
                plannedOrderDocSaveMethod: ['savePersonalChuanLianDoc', 'saveReceivedChuanLianDoc'],
                plannedOrderDocSubmitMethod: ['PersonalSubmitDoc', 'ReceivedSubmitDoc'],
                btnRights: {},
            };
            $scope.data = {
                userName: '',
                METADATAID: angular.isDefined($state.params.iwometadataid) ? $state.params.iwometadataid : '0',
                channelItems: [
                    { name: '电视', value: 15 },
                    { name: '广播', value: 16 },
                ],
                columnItems: [{ name: '请先选择产品' }],
                minDate: $filter('date')(new Date(), 'yyyy-MM-dd hh:mm:ss'),
            };
            $scope.data.selectedChannelItem = $scope.data.channelItems[0];
            initBtnRights();
            emitCloseWindow();
            $scope.editFlag = {
                media: 'iwo', 
                docType: 'planorder',
            };
        }

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function() {
            //     localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.iwometadataid }));
            // };
            editingCenterService.allAppCloseWindow($scope, {typeName: 'iwo', saveLocal: false});
        }

        /**
         * [initBtnRights description] 初始化按钮权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            var methodnameArray = ['iwo.personal', 'iwo.received'];
            initeditctrBtnsService.initIwoData(methodnameArray[$state.params.iwoplatform]).then(function(data) {
                data.forEach((item, index) => {
                    $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                });
            });
            publicToolService.getModeconfiguration('IM').then((config) => {
                $scope.status.IM = config;
            });
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            getSites().then(function() {
                ($state.params.iwometadataid ? initEditData() : initNewData()).then(function() {
                    beforeonload.beforeonloadAlert($scope);
                    // return getAllColumns();
                });
            });
        }

        /**
         * [initNewData description] 新建串联单数据初始化
         * @return {[type]} [description]
         */
        function initNewData() {
            var defer = $q.defer();
            $scope.list = initiWoDataService.initPlannedOrder();
            defer.resolve();
            return defer.promise;
        }

        /**
         * [initEditData description] 编辑串联单数据初始化
         * @return {[type]} [description]
         */
        function initEditData() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.data.selectedChannelItem.value == 15 ? 'mlf_fusiontv' : 'mlf_fusionbroadcast',
                methodname: 'getVirtualChuanLianDoc',
                SourceDocId: $scope.data.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.list = data;
                document.title = data.TITLE;
                $scope.data.selectedColumn = {
                    name: $scope.list.QUOTECHNLDESC,
                    value: $scope.list.QUOTECHNLID,
                };
                $scope.data.selectedSite = {
                    name: $scope.list.WEBSITEDESC,
                    value: $scope.list.WEBSITEID,
                };
                $scope.getAllColumns();
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [getSites description] 获取站点
         * @return {[type]} [description]
         */
        function getSites() {
            var defer = $q.defer();
            editingCenterService.querySitesByMediaType($scope.data.selectedChannelItem.value).then(function(data) {
                $scope.data.sites = data.DATA.map(function(item) {
                    return {
                        name: item.SITEDESC,
                        value: item.SITEID,
                    };
                });
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [changeChannel 切换发布渠道]
         * @return {[type]} [description]
         */
        $scope.changeChannel = function() {
            $scope.data.selectedSite = { name: '请先选择产品' };
            $scope.data.columnItems = [{ name: '请选择栏目' }];
            $scope.data.selectedColumn = $scope.data.columnItems[0];
            getSites();
        };

        /**
         * [getAllColumns description] 获取全部栏目
         * @return {[type]} [description]
         */
        $scope.getAllColumns = function() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.data.selectedChannelItem.value == 15 ? 'mlf_tv' : 'mlf_broadcast',
                methodname: 'getAllChannelsOfDaibian',
                webSiteId: $scope.data.selectedSite.value,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.columnItems = [];
                if (Object.prototype.toString.call(data) == '[object Array]') {
                    var items = [];
                    angular.forEach(data, function(obj, index) {
                        items.push({
                            name: obj.CHNLDESC,
                            value: obj.CHANNELID,
                        });
                    });
                    $scope.data.columnItems = $scope.data.columnItems.concat(items);
                }
                defer.resolve();
            });
            return defer.promise;
        };

        /**
         * [saveBasicDoc description] 基础串联单保存
         * @return {[type]} [description]
         */
        function saveBasicDoc() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: $state.params.fromType ? 'saveDeptNews' : $scope.status.plannedOrderDocSaveMethod[$state.params.iwoplatform],
                METADATAID: $scope.data.METADATAID,
                QUOTECHNLID: $scope.data.selectedColumn.value,
                PREDATE: $scope.list.PREDATE,
                DeptmentalDocId: $state.params.departmentaldocid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [saveTvDoc description] 电视串联单保存
         * @return {[type]} [description]
         */
        function saveTvDoc() {
            var defer = $q.defer();
            var list = angular.copy($scope.list);
            (list.serviceid = $scope.data.selectedChannelItem.value == 15 ? 'mlf_fusiontv' : 'mlf_fusionbroadcast'),
            (list.methodname = 'saveChaunLianDoc');
            list.SOURCEDOCID = $scope.data.METADATAID;
            list.QUOTECHNLID = $scope.data.selectedColumn.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function(data) {
                $scope.list.METADATAID = data.METADATAID;
                $scope.list.CHANNELID = data.CHANNELID;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [checkTodayData description] 判断设置的预播日期是否有串联单
         * @return {[type]} [description]
         */
        function checkTodayData() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.data.selectedChannelItem.value == 15 ? 'mlf_tv' : 'mlf_broadcast',
                methodname: 'checkTodayHasChuanLian',
                PreDate: $scope.list.PREDATE,
                CHANNELID: $scope.data.selectedColumn.value,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                function(data) {
                    defer.resolve();
                },
                function(data) {
                    modalDialog.alertType('', data.DETAIL, 'warning', true, function() {
                        defer.resolve();
                    });
                }
            );
            return defer.promise;
        }

        /**
         * [save description] 保存
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        function save(type) {
            var defer = $q.defer();
            $scope.plannedOrderForm.$pending = {};
            $validation
                .validate($scope.plannedOrderForm)
                .success(function() {
                    modalDialog.isSecretInformation(
                        $state.params.iwometadataid,
                        function() {
                            ($scope.data.METADATAID != 0
                                ? saveBasicDoc()
                                : checkTodayData().then(function() {
                                    return saveBasicDoc();
                                })
                            ).then(function(data) {
                                $scope.data.METADATAID = data.METADATAID;
                                saveTvDoc().then(function() {
                                    beforeonload.refresh($scope);
                                    defer.resolve(data);
                                });
                            });
                        },
                        function(data) {
                            // 有敏感词，并且点击确定修改敏感词
                            defer.reject();
                        },
                        false
                    );
                })
                .error(function() {
                    defer.reject();
                });
            return defer.promise;
        }

        /**
         * [save description] 保存方法
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.save = function(type) {
            type = angular.isDefined(type) ? type : true;
            var defer = $q.defer();
            save(type).then(
                function(data) {
                    $state.params.iwochnldocid = data.CHNLDOCID;
                    $state.params.iwometadataid = data.METADATAID;
                    if (type) {
                        storageListenerService.addListenerToIwo('plannerOrderSaved');
                        $timeout(function() {
                            modalDialog.saveModel('保存成功', '', 'success');
                        }, 500);
                        editIsLock.lockDraft($state.params.iwometadataid);
                        $state.transitionTo($state.current, $state.params, {
                            reload: false,
                        });
                    }
                    defer.resolve();
                },
                function(msg) {
                    defer.reject(msg);
                }
            );
            return defer.promise;
        };

        /**
         * [close description]页面关闭
         * @return {[type]} [description]
         */
        $scope.close = function() {
            var opened = $window.open('about:blank', '_self');
            opened.close();
        };

        /**
         * [submit description] 提交
         * @return {[type]} [description]
         */
        $scope.submit = function() {
            $scope.save(true).then(function () { // 提交放在保存后是因为提交内逻辑是需要实体稿件信息才能执行
                if ($state.params.departmentaldocid){ // 部门稿库需要加锁
                    editIsLock.lockDraft($state.params.iwometadataid);   
                }
                $scope.submitList = [{
                    CHNLDOCID: $state.params.iwochnldocid,
                    METADATAID: $state.params.iwometadataid,
                    DOCTYPEID: '11',
                }];
                newMediaService.iwoSubmit($scope, $scope.status.plannedOrderDocSubmitMethod[$state.params.iwoplatform]);
            });
            // $scope.save(false).then(function() {
            //     editIsLock.normalLock($state.params.iwometadataid);
            //     modalDialog.alertType(
            //         '',
            //         '确认提交到' + $scope.data.selectedColumn.name + '?',
            //         'ask',
            //         true,
            //         function() {
            //             var defer = $q.defer();
            //             var params = {
            //                 serviceid: 'mlf_fusionmyrelease',
            //                 methodname: $scope.status.plannedOrderDocSubmitMethod[$state.params.iwoplatform],
            //                 MetaDataIds: $scope.data.METADATAID,
            //                 CHNLDOCIDS: $state.params.iwochnldocid,
            //                 // TvWenGao: $scope.list.CHANNELID
            //             };
            //             $scope.data.selectedChannelItem.value == 15
            //                 ? (params.TvWenGao = $scope.list.CHANNELID)
            //                 : (params.BroadCastWenGao = $scope.list.CHANNELID);
            //             $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            //                 modalDialog.alertType('', '提交成功', 'success', false, function() {
            //                     storageListenerService.addListenerToIwo('plannerOrderSubmit');
            //                     var opened = $window.open('about:blank', '_self');
            //                     opened.close();
            //                 });
            //             });
            //         },
            //         function() {}
            //     );
            // });
        };
        // 传稿(个人稿库+已收稿库)
        $scope.iWoTransfer = function() {
            $scope.save(false).then(function() {
                editIsLock.normalLock($state.params.iwometadataid);
                draft();
            });
        };
        // 传稿触发结束
        // 传稿函数
        function draft() {
            var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
            myManuscriptService.draft(
                '传稿',
                [
                    {
                        TITLE: '',
                        CHNLDOCID: $state.params.iwochnldocid,
                        METADATAID: $state.params.iwometadataid,
                        DOCTYPEID: 11,
                    },
                ],
                function() {
                    storageListenerService.addListenerToIwo('manuscriptPassed');
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                },
                function() {},
                menthod[$state.params.iwoplatform]
            );
        }
    },
]);
